import { forwardRef, useState, useEffect, useImperativeHandle } from "react";

const FormAutoComplete = forwardRef(function FormAutoComplete(props, ref) {
  const {
    label,
    bottomLabel,
    name,
    required = false,
    placeholder = "Välj stad",
    itemName,
    items = [],
    disabled = false,
  } = props;

  const [inputValue, setInputValue] = useState("");
  const [cityID, setCityID] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (placeholder !== "Välj stad") {
      const value = { name: placeholder.name, id: placeholder.id };
      handleSelect(value);
    }
  }, []);

  const filteredItems =
    inputValue && items
      ? items.filter((item) => {
          const value = typeof item === "object" ? item.name ?? "" : item ?? "";
          return value.toLowerCase().includes(inputValue.toLowerCase());
        })
      : [];

  const handleSelect = (value) => {
    setInputValue(value.name);
    setCityID(value.id);
    setShowDropdown(false);
  };

  useImperativeHandle(ref, () => ({
    focus: () => document.getElementsByName(name)[0]?.focus(),
  }));

  return (
    <label
      className="form-control max-w-xs my-4"
      style={{ position: "relative" }}
    >
      <div className="label">
        <span className="label-text">{label}</span>
      </div>

      {/* Hidden input that actually gets submitted */}
      <input type="hidden" name={name} value={cityID} />

      {/* Visible input just for display & searching */}
      <input
        type="text"
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          setShowDropdown(true);
        }}
        className="input input-bordered max-w-xs"
        ref={ref}
        autoComplete="off"
        onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
      />

      {showDropdown && filteredItems.length > 0 && (
        <ul className="absolute z-10 bg-white border rounded w-full mt-1 max-h-48 overflow-auto text-black">
          {filteredItems.map((item, idx) => (
            <li
              key={idx}
              className="px-4 py-2 cursor-pointer hover:bg-base-200"
              onClick={() => handleSelect(item)}
            >
              {item.name}
            </li>
          ))}
        </ul>
      )}

      {bottomLabel && (
        <div className="label">
          <span className="label-text-alt">{bottomLabel}</span>
        </div>
      )}
    </label>
  );
});

FormAutoComplete.displayName = "FormAutoComplete";

export default FormAutoComplete;
